<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
      d="
        M4 7v2h24V7Zm0 8v2h24v-2Zm0 8v2h24v-2Z
      "
    />
  </svg>
</template>
